var _polygon, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21.293,14.343 16.886,18.75 16.887,2.698 15.554,2.698 15.553,18.75 11.146,14.343 10.204,15.286 16.22,21.302  22.236,15.286 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.937,4.78l-2.173,5.434h0.569c0.063,0,0.116-0.018,0.159-0.053c0.043-0.036,0.072-0.076,0.087-0.121l0.508-1.312h2.438 l0.508,1.312c0.02,0.051,0.051,0.092,0.091,0.125c0.041,0.033,0.094,0.049,0.159,0.049h0.569L4.68,4.78H3.937z M3.292,8.196 l0.853-2.207C4.173,5.924,4.201,5.847,4.227,5.76c0.027-0.087,0.052-0.18,0.078-0.279C4.333,5.58,4.36,5.672,4.386,5.758 C4.413,5.844,4.44,5.92,4.468,5.986l0.853,2.211H3.292V8.196z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.394,14.479h3.007l-3.079,4.33c-0.021,0.033-0.037,0.067-0.051,0.102c-0.014,0.035-0.021,0.073-0.021,0.114v0.288h4.073 v-0.599h-3.11l3.079-4.319c0.051-0.078,0.076-0.159,0.076-0.242V13.88H2.394V14.479z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/SortAscending.502b502a.svg";
export { ForwardRef as ReactComponent };